'use strict';

//import './aexp-pzn-expiry-modal.scss';

import AexpPznExpiryModal from './aexp-pzn-expiry-modal.tpl';

export { AexpPznExpiryModal };
